import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

const ToggleableLink = (props) => {
  const { disabled, ...rest } = props;
  return disabled ? (
    <div
      className="btn btn-light rounded-pill"
      style={{ pointerEvents: "none", opacity: "0.8" }}
      disabled
    >
      {props.children}
    </div>
  ) : (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Tooltip style={{ zIndex: 999999999999 }} {...props}>
          Ver resumen de evaluación
        </Tooltip>
      }
    >
      <Link
        {...rest}
        className="rounded-pill d-flex flex-wrap justify-content-center align-items-center"
        style={{ textDecoration: "none" }}
        variant="light"
        to={`/resumen-general-de-evaluaciones/${props.idColab}/${props.nombreColab}/${props.idFuncion}/${props.nombreFuncion}/${props.idDep}/${props.nombreDep}/${props.evaluation.listado_evaluaciones.evaluaciones_factor[0][0]}/${props.idEmpresa}`}
        // target="_blank"
      >
        {props.children}
      </Link>
    </OverlayTrigger>
  );
};

export default ToggleableLink;
